import React, { useState } from 'react';
import Box from '@mui/material/Box';
import TabContext from '@mui/lab/TabContext';
import TabPanel from '@mui/lab/TabPanel';
import { Grid, TextField, Autocomplete } from '@mui/material';
import CommonTable from 'components/commonTable/CommonTable';
import DateTab from 'pages/date/Date';
import FeedBackHeader from './FeedBackHeader';
import CommonFilter from 'components/commonFilter/CommonFilter';
import Loader from 'components/loader/Loader';
import { useDispatch, useSelector } from 'react-redux';
import CommonSDF from 'components/commonSDF/CommonSdf';

function FeedbackTab(props) {
  const onClickTableFeedback = (data) => {
    props.onClickTableFeedback(data)
  }

  return (
    <Grid container>
      <Grid item className="tableContainer" xs={12}>
        <Box className="contentBoxStyle marginBlock10">
          <TabContext value={props?.value}>
            <Grid
              container
              className="tabBoxStyle"
              direction="row"
              justifyContent="space-between"
              alignItems="center"
            >
              <Grid
                item
                container
                direction="row"
                justifyContent="flex-end"
                alignItems="center"
                xs={12}

                className='mb15'
              >
                <Box sx={{
                      flex: 1,
                      display: 'flex',
                    }}>
                <CommonSDF
                  onSelectDateRange={props?.onSelectDateRange}
                   tabName={props?.tabName} 
                   dateFrom={props?.dateFrom}
                   dateTo={props?.dateTo}
                   defaultStatus={props?.defaultStatus}
                   filterdata={props?.filterData} 
                   onFilterChange={props?.onFilterChange} 
                   onRestFilter={props?.onRestFilter}
                />
                </Box>
              </Grid>
            </Grid>
            <FeedBackHeader tableData={props?.tableData} onRating={props?.onRating} status={props?.status} statusCard={props?.statusCard} />
            <TabPanel value="Driver" className="tabPanelStyle">
              {props?.isLoading ? <Loader /> : <CommonTable data={props?.tableData} onClickTableVendor={onClickTableFeedback}
                handleChangePage={props?.handleChangePage}
                handleChangeRowsPerPage={props?.handleChangeRowsPerPage}
                page={props?.page}
                isClickable={false}
                rowsPerPage={props?.rowsPerPage} />}
            </TabPanel>
            <TabPanel value="Customer" className="tabPanelStyle">
              {props?.isLoading ? <Loader /> : <CommonTable data={props?.tableData} onClickTableVendor={onClickTableFeedback}
                handleChangePage={props?.handleChangePage}
                handleChangeRowsPerPage={props?.handleChangeRowsPerPage}
                page={props?.page}
                isClickable={false}
                rowsPerPage={props?.rowsPerPage} />}
            </TabPanel>
          </TabContext>
        </Box>
      </Grid>
    </Grid>
  );
}

export default FeedbackTab;
